import { Fragment, ReactElement, useState } from 'react';
import { CloseIcon } from '../assets/icons/Icons';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
} from '@mui/material';
import { DialogBackground, DialogTitleStyle } from '../assets/theme/Theme';

interface AlertDialogProps {
	id: string;
	title: string;
	bodyContent: string;
	deleteData: (value: string) => void;
	icon: ReactElement;
	cancelBtnText: string;
	deleteBtnText: string;
}

export const AlertDialog = (props: AlertDialogProps) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const deleteItem = () => {
		props.deleteData(props.id);
		handleClose();
	};
	return (
		<Fragment>
			<IconButton onClick={handleClickOpen}>{props.icon}</IconButton>
			<Dialog
				open={open}
				onClose={handleClose}
				maxWidth="sm"
				fullWidth={true}
				style={DialogBackground}>
				<DialogTitle style={DialogTitleStyle}>
					{props.title}
					<IconButton onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<DialogContentText
						variant="subtitle1"
						style={{
							color: 'rgba(113, 113, 113, 1)',
							fontWeight: 600,
						}}>
						{props.bodyContent}
					</DialogContentText>
				</DialogContent>
				<DialogActions
					style={{ marginRight: '20px', marginBottom: '20px' }}>
					<Button
						sx={{
							paddingLeft: '15px',
							paddingRight: '5px',
							color: '#21C17A',
							textTransform: 'none',
							marginRight: '0px',
						}}
						onClick={handleClose}>
						{props.cancelBtnText}
					</Button>
					<Button
						variant="contained"
						style={{
							backgroundColor: '#21C17A',
							boxShadow: 'none',
							marginLeft: '10px',
							textTransform: 'none',
						}}
						onClick={deleteItem}
						autoFocus>
						{props.deleteBtnText}
					</Button>
				</DialogActions>
			</Dialog>
		</Fragment>
	);
};

export default AlertDialog;
